import { useEffect, useState } from 'react';

const useClientDimensions = () => {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    clientWidth: undefined,
    clientHeight: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleClientResize() {
      // Set window width/height to state
      setWindowSize({
        clientWidth: document.body.clientWidth,
        clientHeight: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener('resize', handleClientResize, { passive: false });
    // Call handler right away so state gets updated with initial window size
    handleClientResize();
    // Remove event listener on cleanup

    return () => window.removeEventListener('resize', handleClientResize, { passive: false });
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
};

export default useClientDimensions;
